import { render, staticRenderFns } from "./FilterManagerParent.vue?vue&type=template&id=2ffe5ebf&scoped=true"
import script from "./FilterManagerParent.vue?vue&type=script&lang=js"
export * from "./FilterManagerParent.vue?vue&type=script&lang=js"
import style0 from "./FilterManagerParent.vue?vue&type=style&index=0&id=2ffe5ebf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe5ebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffe5ebf')) {
      api.createRecord('2ffe5ebf', component.options)
    } else {
      api.reload('2ffe5ebf', component.options)
    }
    module.hot.accept("./FilterManagerParent.vue?vue&type=template&id=2ffe5ebf&scoped=true", function () {
      api.rerender('2ffe5ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/manager/component/FilterManagerParent.vue"
export default component.exports